import { render, staticRenderFns } from "./EditBankAccountDialog.vue?vue&type=template&id=b52be256&scoped=true"
import script from "./EditBankAccountDialog.vue?vue&type=script&lang=js"
export * from "./EditBankAccountDialog.vue?vue&type=script&lang=js"
import style0 from "./EditBankAccountDialog.vue?vue&type=style&index=0&id=b52be256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52be256",
  null
  
)

export default component.exports